import {ValidationObserver, ValidationProvider} from "vee-validate";
import firebase from "firebase/app";
import {GalleryFolder} from "@/models/GalleryFolder";
import moment from "moment/moment";

export default {
  name: "GalleryFolderDlg",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: ""
    }
  },
  computed: {
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    }
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    addFolder() {
      this.loading = true;

      const folder: GalleryFolder = {
        name: this.name,
        facilityId: this.facilityId,
        createdAt: moment(new Date()).toDate()
      }

      firebase
        .firestore()
        .collection("galleryFolders")
        .add(folder)
        .then(() => {
          this.name = "";
          this.$refs.observer.reset();
          this.$toast.open({
            message: this.$t("Gallery.FolderHasBeenAdded"),
            type: "success"
          })
          this.loading = false;
          this.close();
          this.$store.dispatch("getGalleryFolders");
        }).catch(() => {
          this.$toast.open({
            message: this.$t("Gallery.ErrorFolderAdding"),
            type: "error"
          })
         this.loading = false;
      })
    }
  }
}